(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("OnairosLaravel", [], factory);
	else if(typeof exports === 'object')
		exports["OnairosLaravel"] = factory();
	else
		root["OnairosLaravel"] = factory();
})(this, () => {
return 